import { useSelector } from 'react-redux';
import { selectAllRoleGroups } from 'redux/roleGroups/roleGroupsSlice';
import { selectAllApps } from 'redux/apps/appsSlice';
import makeGroupSelData from '../../libs/makeGroupSelData';
import filterUserGroups from '../../libs/filterUserGroups';
import { checkArrayOnlyType } from 'libs/types/checkTypes';
import makeFixedUserGroups from '../../libs/makeFixedUserGroups';
import getMenusApi from 'api/menus/getMenusApi';
import { useEffect, useState } from 'react';

/**
 * @function useUserInfoForm
 * @param {Object[]} loggedInUserGroups
 * @param {string} loggedInUserGroups.userId
 * @param {string} loggedInUserGroups.roleGroupId
 * @param {Object[]} userGroups
 * @param {string} userGroups.id
 * @param {string} userGroups.name
 * @param {string} userGroups.appId
 * @returns {object}
 */
function useUserInfoForm(loggedInUserGroups, userGroups) {
	checkArrayOnlyType(userGroups, loggedInUserGroups);

	const [tabs, setTabs] = useState([]);
	const { apps } = useSelector(selectAllApps);
	const { roleGroups } = useSelector(selectAllRoleGroups);

	const _roleGroups = makeGroupSelData(apps, roleGroups);
	const filteredGroups = filterUserGroups(_roleGroups, loggedInUserGroups);
	const fixedGroups = makeFixedUserGroups(userGroups, loggedInUserGroups);

	// fetch available tabs
	const fetchTabs = () => {
		// fetch tabs
		try {
			getMenusApi().then((res) => {
				const filteredTabs = res.dbTabs
					.filter((tab) => tab.url !== 'Sub-menu') // Filter out "Sub-menu"
					.reduce((uniqueTabs, tab) => {
						const urls = new Set(uniqueTabs.map((t) => t.url)); // Collect seen URLs
						if (!urls.has(tab.url)) {
							uniqueTabs.push(tab); // Add only if the URL is unique
						}
						return uniqueTabs;
					}, []);
				setTabs(filteredTabs);
			});
		} catch (error) {
			console.log('error', error);
		}
	};

	useEffect(() => {
		fetchTabs();
	}, []);

	return { filteredGroups, fixedGroups, tabs };
}

export default useUserInfoForm;
